import { useAuth } from '@hostesa/auth-client';

/**
 * UI-side guard for destructive / sensitive actions during an impersonation
 * session.
 *
 * Returns `restricted: true` whenever the current platform session is an
 * operator acting AS a hotel user (`useAuth().impersonation.active`). Callers
 * use it to disable the affordance — e.g. a Save / Configure / irreversible
 * task control — and explain why.
 *
 * IMPORTANT: this is defence in depth, NOT the security boundary. The backend
 * remains authoritative and rejects denied operations for an impersonated
 * subject (the AI Tool Gateway risk stage keys off `subject.impersonatorUserId`).
 * Disabling the control here only stops an operator firing a destructive action
 * by reflex; never rely on it for enforcement.
 */
export function useImpersonationGuard(): { restricted: boolean } {
  const { impersonation } = useAuth();
  return { restricted: Boolean(impersonation?.active) };
}
